// Auth
export const REACT_APP_WUCA_API_CLIENT_URL =
  process.env.REACT_APP_WUCA_API_CLIENT_URL || "";

export const REACT_APP_WUCA_DXP_API_BEARER_TOKEN =
  process.env.REACT_APP_WUCA_DXP_API_BEARER_TOKEN || "";
export const REACT_APP_APP_INSIGHT_CONNECTION_STRING =
  process.env.REACT_APP_APP_INSIGHT_CONNECTION_STRING || "";

export const REACT_APP_WUCA_DXP_ADMIN_URL =
  process.env.REACT_APP_WUCA_DXP_ADMIN_URL || "";

// logging
export const REACT_PUBLIC_URL_LOG_API =
  process.env.REACT_PUBLIC_URL_LOG_API || "";

export const APP_INSIGNT_INSTRUMENTATION_KEY = process.env.APP_INSIGNT_INSTRUMENTATION_KEY || "";

export const REACT_PUBLIC_URL = process.env.REACT_PUBLIC_URL || "";
export const REACT_APP_WUCA_PUBLIC_URL = process.env.REACT_APP_WUCA_PUBLIC_URL || "";

export const REACT_APP_WUCA_DOCUMENT_API_URL = process.env.REACT_APP_WUCA_DOCUMENT_API_URL || "";

export const REACT_APP_ADOBE_DTM_URL = process.env.REACT_APP_ADOBE_DTM_URL || "";